module.exports = __webpack_public_path__ + "static/media/location_city-24px.4bf4fb89.svg";